import { connect } from "react-redux";
import { func } from "prop-types";

import useModalHandlr from "./hooks";

import { createTasksByUnassignedFilter } from "../actions/creators";

import Clearer from "./fractals";
import { PopoverContent, PopoverItem } from "../../../../shared/v2/Popover";
import ModalSecondaryFilterMember from "../ModalSecondaryFilterMember";
import ModalSecondaryFilterAutoPlans from "../ModalSecondaryFilterAutoPlans ";

import SECONDARY_FILTERS from "./fixtures";

const Drawer = ({ toggleDrawer, onCreateTasksByUnassignedFilter }) => {
  const {
    modalTeamMemberActive,
    setModalTeamMemberActive,
    modalAutoPlansActive,
    setModalAutoPlansActive,
    secondaryFilterHandlr,
  } = useModalHandlr({
    toggleDrawer,
    onCreateTasksByUnassignedFilter,
  });

  return (
    <>
      <ModalSecondaryFilterMember
        show={modalTeamMemberActive}
        setModalTeamMemberActive={setModalTeamMemberActive}
      />
      <ModalSecondaryFilterAutoPlans
        show={modalAutoPlansActive}
        setModalAutoPlansActive={setModalAutoPlansActive}
      />
      <PopoverContent>
        {SECONDARY_FILTERS.map((filterTxt) => (
          <PopoverItem
            key={filterTxt}
            className="tw-whitespace-nowrap"
            onClick={() => secondaryFilterHandlr(filterTxt)}
          >
            {filterTxt}
          </PopoverItem>
        ))}
        <hr className="tw-m-0 tw-border-[1px] tw-border-solid tw-border-gray-10" />
        <div className="tw-flex tw-justify-start tw-py-[4px] tw-pl-[6px] tw-pr-[12px]">
          <Clearer toggleDrawer={toggleDrawer} />
        </div>
      </PopoverContent>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  onCreateTasksByUnassignedFilter: () => dispatch(createTasksByUnassignedFilter()),
});

Drawer.propTypes = {
  toggleDrawer: func,
  onCreateTasksByUnassignedFilter: func,
};

Drawer.defaultProps = {
  toggleDrawer: () => {},
  onCreateTasksByUnassignedFilter: () => {},
};

export default connect(null, mapDispatchToProps)(Drawer);
